import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import { EntityAvatar } from "../../Partials/Avatar/EntityAvatar";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import UserProfileWillMount from "../../../Middleware/Middlewares/UserProfileWillMount";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { UserSettingsInterface } from "../../../Entity/Entities/Settings/User/UserSettingsInterface";
import Select from "../../Partials/Material/Select";
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import Time from "../../../Time/Time";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { Attachment } from "../../Partials/Attachment/Attachment";

class UserProfile extends Component {
  public state = {
    firstName: "",
    lastName: "",
    email: "",
    phone1: "",
    phone2: "",
    profession: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    openLeavePrompt: false,
    newEmail: "",
    confirmEmail: "",
    displayLess: true,
    displayMore: false,
    mainBankAccountId: null,
    mainBankAccountName: null,
    dateOfBirth: null,
    identityNumber: null,
    identityType: 255,
    note: "",
    confirmEmailNotValid: false,
    nextPath: "",
    isSaving: false,
    attachments: [],
    address: {
      formattedAddress: "",
    },
    documentAddress: {
      formattedAddress: "",
    },
    selectedTabIndex: 0,

    language: "",
    locale: "",
    currency: 1,
    beta: false,
    languageWasChanged: false,
    expanded: null,
    user: null,
    placeOfBirthAddress: {
      formattedAddress: "",
    },
    errorChangeEmailId: null,
    languageTypeId: 1,
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_SETTINGS_USER_PROFILE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    UserProfileWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    const user = nextProps.app.persons.filter(
      person => person.id === nextProps.app?.session?.user?.id
    )[0];

    this.setState({
      attachments: !!user ? user.attachments : [],
      user: user
    });
  }

  public changePassword = (): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_START,
        payload: {
          data: {
            oldPassword: this.state.oldPassword,
            newPassword: this.state.newPassword,
            confirmPassword: this.state.confirmPassword
          }
        },
        onSuccess: () => {
          this.setState({
            oldPassword: "",
            newPassword: "",
            confirmPassword: ""
          });

          this.setState({
            isSaving: false
          }, () => {
            if (this.state.nextPath) {
              return this.redirect(this.state.nextPath);
            }
          });
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public changeEmail  = () => {
    if (!this.state.newEmail || !this.state.confirmEmail || this.state.newEmail !== this.state.confirmEmail) {
      return this.setState({
        confirmEmailNotValid: true
      });
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_START,
        payload: {
          data: {
            newEmail: this.state.newEmail,
            userId: this.state.user?.id,
          }
        },
        onSuccess: () => {
          this.setState({
            isSaving: false,
            newEmail: "",
            confirmEmail: ""
          }, () => {
            if (this.state.nextPath) {
              return this.redirect(this.state.nextPath);
            }
          });
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            errorChangeEmailId: err?.errorId
          });
        }
      });
    });
  }

  public save = (): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_SETTINGS_USER_PROFILE_UPDATE_START,
        payload: {
          id: this.state.user?.id,
          isFromDialog: false,
          person: {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            profession: this.state.profession,
            phone1: this.state.phone1,
            phone2: this.state.phone2,
            contactRoleId: this.state.user?.role?.getRoleId(),
            mainBankAccountId: this.state.mainBankAccountId,
            mainBankAccountName: this.state.mainBankAccountName,
            bankAccount: {
              accountId: this.state.mainBankAccountId,
              name: this.state.mainBankAccountName
            },
            dateOfBirth: Time.formatOrNull(this.state.dateOfBirth),
            placeOfBirth: this.state.placeOfBirthAddress,
            identityNumber: this.state.identityNumber,
            identityType: this.state.identityType,
            address: Object.keys(this.state.address || {}).length > 0 ? { ...this.state.address } : null,
            note: this.state.note,
            documentAddress: this.state.documentAddress,
            company: this.getAgency(),
            languageTypeId: this.state.languageTypeId,
          }
        },
        onSuccess: () => {
          this.setState({
            isSaving: false
          }, () => {
            if (this.state.nextPath) {
              return this.redirect(this.state.nextPath);
            }
          });
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public setConfirmEmail = (event) => {
    const confirmEmail = event.target.value;

    this.setState({
      confirmEmail: confirmEmail,
      confirmEmailNotValid: false
    });
  }

  public selectCountry = (event) => {
    this.setState({
      documentAddress: event,
      hasModifiedData: true,
    })
  }

  public clearCountry = () => {
    this.setState({
      documentAddress: {
        formattedAddress: "",
      },
      hasModifiedData: true,
    })
  }

  public changeLanguage = (event) => {
    this.setState({
      language: event.target.value,
      languageWasChanged: true,
      hasModifiedData: true
    }, () => {
      this.savePreferences();
    });
  }

  public changeLocale = (event) => {
    this.setState({
      locale: event.target.value,
      hasModifiedData: true
    }, () => {
      this.savePreferences();
    });
  }

  public changeCurrency = (event) => {
    this.setState({
      currency: event.target.value,
      hasModifiedData: true
    }, () => {
      this.savePreferences();
    });
  }

  public selectPlaceOfBirth = (event) => {
    this.setState({
      placeOfBirthAddress: event,
      hasModifiedData: true,
    })
  }

  public clearPlaceOfBirth = () => {
    this.setState({
      placeOfBirthAddress: {
        formattedAddress: "",
      },
      hasModifiedData: true,
    })
  }

  public savePreferences = (): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_START,
        payload: {
          preferences: {
            language: this.state.language,
            locale: this.state.locale,
            beta: this.state.beta,
            currency: this.state.currency,
            userId: this.props.app.session.user.id
          }
        },
        onSuccess: (settings: UserSettingsInterface) => {
          this.translator.use(settings && settings.language && settings.language.iso);

          // if (this.state.languageWasChanged) {
          //   Places.changeLanguage(settings && settings.language && settings.language.iso);
          // }

          this.forceUpdate();

          this.setState({
            isSaving: false
          }, () => {
            if (this.state.nextPath) {
              return this.redirect(this.state.nextPath);
            }
          });
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public switchUsingBeta = () => {
    this.setState({
      beta: !this.state.beta
    }, () => {
      this.savePreferences();
    });
  }

  public handleChangeExpansionPanel = panel => (event, expanded) => {
    event
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  public render() {
    return (
      <div style={{width: "100%"}}>
        <ExpansionPanel className="expansion-panel" expanded={this.state.expanded === 'settingsUserProfile'} onChange={this.handleChangeExpansionPanel('settingsUserProfile')}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            {
              <div className="expansion-panel-title">{this.trans("settings-user-profile-title")}</div>
            }
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <Card className="card">
            <div className="row">
              <div className="grid align-icon-grid">
                <EntityAvatar
                  {...this.props}
                  ref="EntityAvatar"
                  entityName="person"
                />
              </div>
              <div className="grid" style={{marginBottom: "20px"}}>
                <form>
                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-firstName"
                    type="text"
                    label={this.trans("label-first-name")}
                    value={this.state.firstName}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
                    autoFocus={true}
                    variant="standard"
                    error={!!this.getErrorFor("firstName")}
                  />
                  {!!this.getErrorFor("firstName") && <div className="component-error-text">{this.getErrorFor("firstName")}</div>}

                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-lastName"
                    type="text"
                    label={this.trans("label-last-name") + this.trans("field/optional")}
                    value={this.state.lastName}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
                    variant="standard"
                    error={!!this.getErrorFor("lastName")}
                  />
                  {!!this.getErrorFor("lastName") && <div className="component-error-text">{this.getErrorFor("lastName")}</div>}

                  {/* <Select
                    className="form-element full-size form-input scroll-to-identityType correct-label-position"
                    error={this.getErrorFor("language")}
                    variant="standard"
                    value={this.state.languageTypeId}
                    onChange={this.sync.bind(this, this.syncronizers.LANGUAGE_TYPE)}
                    htmlFor="identityDocumentType"
                    label={this.trans("language")}
                    name="languageType"
                    id="languageType"
                  >
                    {this.getLanguageTypeSelectboxes()}
                  </Select> */}

                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-phone1"
                    type="text"
                    label={this.trans("label-mob-number") + this.trans("field/optional")}
                    value={this.state.phone1}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
                    variant="standard"
                    error={!!this.getErrorFor("phone1")}
                  />
                  {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}

                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-phone2"
                    type="text"
                    label={this.trans("other-phone") + this.trans("field/optional")}
                    value={this.state.phone2}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone2")}
                    variant="standard"
                    error={!!this.getErrorFor("phone2")}
                  />
                  {!!this.getErrorFor("phone2") && <div className="component-error-text">{this.getErrorFor("phone2")}</div>}

                  {this.state.displayLess && (
                    <Button
                      color="primary"
                      onClick={() => this.setState({displayMore: true, displayLess: false})}
                      style={{width: "100%", marginTop: "10px"}}
                    >
                      {this.trans("button-show-more")}
                    </Button>
                  )}

                  {this.state.displayMore && (
                    <React.Fragment>
                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-profession"
                        type="text"
                        label={this.trans("profession") + this.trans("field/optional")}
                        value={this.state.profession}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "profession")}
                        variant="standard"
                        error={!!this.getErrorFor("profession")}
                      />
                      {!!this.getErrorFor("profession") && <div className="component-error-text">{this.getErrorFor("profession")}</div>}

                      <DatePickerComponent
                        {...this.props}
                        className="scroll-to-dateOfBirth"
                        label={this.trans("date-of-birth") + this.trans("field/optional")}
                        initialDate={this.state.dateOfBirth}
                        onChange={date => this.setState({ dateOfBirth: date, hasModifiedData: true })}
                        clearButton={true}
                        error={this.getErrorFor("dateOfBirth")}
                      />

                      <AddressSelector
                        {...this.props}
                        // id="address"
                        // name="address.googlePlaceId"
                        className="scroll-to-documentAddress"
                        labelText={this.trans("place-of-birth") + this.trans("field/optional")}
                        searchText={this.state.placeOfBirthAddress.formattedAddress ? this.state.placeOfBirthAddress.formattedAddress : null}
                        selectedAddress={this.state.placeOfBirthAddress}
                        onSelect={this.selectPlaceOfBirth}
                        onClear={this.clearPlaceOfBirth}
                        //countryList={true}
                        error={this.getErrorFor("placeOfBirth")}
                      />

                      <Select
                        className="form-element full-size form-input scroll-to-identityType correct-label-position"
                        error={this.getErrorFor("identityType")}
                        variant="standard"
                        value={this.state.identityType}
                        onChange={this.sync.bind(this, this.syncronizers.IDENTITY_TYPE)}
                        htmlFor="identityDocumentType"
                        label={this.trans("identity-document-type") + this.trans("field/optional")}
                        name="identityDocumentType" 
                        id="identityDocumentType"
                      >
                        {this.getIdentityTypeSelectboxes()}
                      </Select>

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-identityNumber"
                        type="text"
                        label={this.trans("identity-document-number") + this.trans("field/optional")}
                        value={this.state.identityNumber}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "identityNumber")}
                        variant="standard"
                        error={!!this.getErrorFor("identityNumber")}
                      />
                      {!!this.getErrorFor("identityNumber") && <div className="component-error-text">{this.getErrorFor("identityNumber")}</div>}

                      <AddressSelector
                        {...this.props}
                        // id="address"
                        // name="address.googlePlaceId"
                        className="scroll-to-documentAddress"
                        labelText={this.trans("dropdown/documentcountry-label") + this.trans("field/optional")}
                        searchText={this.state.documentAddress.formattedAddress ? this.state.documentAddress.formattedAddress : null}
                        selectedAddress={this.state.documentAddress}
                        onSelect={this.selectCountry}
                        onClear={this.clearCountry}
                        countryList={true}
                      />

                      <AddressSelector
                        {...this.props}
                        name="address.googlePlaceId"
                        className="scroll-to-address"
                        searchText={this.state.address.formattedAddress ? this.state.address.formattedAddress : null}
                        selectedAddress={this.state.address}
                        onSelect={this.sync.bind(this, this.syncronizers.VALUE, "address")}
                        onClear={this.sync.bind(this, this.syncronizers.VALUE, "address", {})}
                      />

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-mainBankAccountId"
                        type="text"
                        label={this.trans("label-bank-account-id") + this.trans("field/optional")}
                        value={this.state.mainBankAccountId}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountId")}
                        variant="standard"
                        error={!!this.getErrorFor("mainBankAccountId")}
                      />
                      {!!this.getErrorFor("mainBankAccountId") && <div className="component-error-text">{this.getErrorFor("mainBankAccountId")}</div>}

                      <TextField
                        autoComplete="off"
                        // id="mainBankAccountName"
                        // name="mainBankAccountName"
                        className="form-element full-size scroll-to-mainBankAccountName"
                        type="text"
                        label={this.trans("label-bank-account-name") + this.trans("field/optional")}
                        value={this.state.mainBankAccountName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "mainBankAccountName")}
                        variant="standard"
                        error={!!this.getErrorFor("mainBankAccountName")}
                        helperText={this.getErrorFor("mainBankAccountName")}
                      /> 

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-note"
                        type="text"
                        multiline={true}
                        rowsMax={10}
                        label={this.trans("note") + this.trans("field/optional")}
                        value={this.state.note}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                        variant="standard"
                        error={!!this.getErrorFor("note")}
                      />
                      {!!this.getErrorFor("note") && <div className="component-error-text">{this.getErrorFor("note")}</div>}

                      <Button
                        color="primary"
                        onClick={() => this.setState({displayMore: false, displayLess: true})}
                        style={{width: "100%", marginTop: "10px"}}
                      >
                        {this.trans("button-show-less")}
                      </Button>
                    </React.Fragment>
                  )}
                </form>
                <Button
                  variant="contained"
                  color="primary"
                  className="form-button"
                  disabled={this.props.component.isSavingProfile}
                  onClick={this.save}
                  style={{margin: "10px 0"}}
                >
                  {this.props.component.isSavingProfile === true ? this.trans("button-saving") : this.trans("button-save")}
                </Button>
              </div>
            </div>
          </Card> 
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel className="expansion-panel" expanded={this.state.expanded === 'preferences'} onChange={this.handleChangeExpansionPanel('preferences')}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            {
              <div className="expansion-panel-title">{this.trans("preferences")}</div>
            }
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="row" style={{width: "400px", marginLeft: "23px"}}>
              <div className="grid"></div>
              <div className="grid">
                <form>
                  <Select
                    className="form-element full-size form-input scroll-to-defaultLanguage correct-label-position"
                    error={this.getErrorFor("defaultLanguage")}
                    value={this.state.language}
                    onChange={this.changeLanguage}
                    htmlFor="defaultLanguage"
                    label={this.trans("language")}
                    name="defaultLanguage" 
                    id="defaultLanguage"
                  >
                    {this.getLanguageSelectboxes()}
                  </Select>

                  <Select
                    className="form-element full-size form-input scroll-to-defaultLocale correct-label-position"
                    error={this.getErrorFor("defaultLocale")}
                    value={this.state.locale}
                    onChange={this.changeLocale}
                    htmlFor="defaultLocale"
                    label={this.trans("locale")}
                    name="defaultLocale" 
                    id="defaultLocale"
                  >
                    {this.getLocaleSelectboxes()}
                  </Select>

                  <Select
                    className="form-element full-size form-input scroll-to-currency correct-label-position"
                    error={this.getErrorFor("currency")}
                    value={this.state.currency}
                    onChange={this.changeCurrency}
                    htmlFor="currency"
                    label={this.trans("label-currency")}
                    name="currency" 
                    id="currency"
                  >
                    {this.getCurrencySelectboxes()}
                  </Select>

                  {
                    this.props
                      && this.props.app
                      && this.props.app.session
                      && this.props.app.session.user
                      && typeof this.props.app.session.user.isAdmin === "function"
                      && this.props.app.session.user.isAdmin() && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.beta}
                              style={{margin: "20px 0"}}
                              onChange={this.switchUsingBeta}
                              color="primary"
                            />
                          }
                          label={this.trans("use-beta-version-features")}
                        />
                      )
                  }
                </form>
              </div>
            </div>  
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel className="expansion-panel" expanded={this.state.expanded === 'changeEmail'} onChange={this.handleChangeExpansionPanel('changeEmail')}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>            
            {
              <div className="expansion-panel-title">{this.trans("change-email")}</div>
            }
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="row" style={{width: "400px",  marginLeft: "23px"}}>
              <div className="grid"></div>
              <div className="grid">
                <form>
                  {
                    this.state.user?.newEmail && (
                    <div style={{display: "flex", alignItems: "flex-start", justifyContent: "flex-start", color: "green", fontSize: "12px", margin: "10px 0 20px 10px"}}>
                      <div className="icon icon-ic-check-circle" style={{color: "green", marginRight: "10px"}}></div>
                      <div>{this.trans("verification-email-sent", {currentEmail: this.state.user?.email, newEmail: this.state.user?.newEmail})}</div>
                    </div>
                  )}
                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-email"
                    label={this.trans("current-label-email")}
                    value={this.state.email}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
                    variant="standard"
                    disabled={true}
                    error={!!this.getErrorFor("email")}
                  />
                  {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}
                  <TextField
                    autoComplete="off"
                    className="form-element full-size"
                    label={this.trans("new-email")}
                    value={this.state.newEmail}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "newEmail")}
                    variant="standard"
                    error={(this.state.confirmEmailNotValid && !!this.trans("confirm-email-should-be-equal")) || !!this.getErrorFor("newEmail") || this.state.errorChangeEmailId}
                  />
                  {this.state.confirmEmailNotValid ? <div className="component-error-text">{this.trans("confirm-email-should-be-equal")}</div>
                  :
                  this.state.errorChangeEmailId && <div className="component-error-text">{this.trans(this.state.errorChangeEmailId)}</div>
                  }
                  <TextField
                    autoComplete="off"
                    className="form-element full-size"
                    label={this.trans("confirm-email")}
                    value={this.state.confirmEmail}
                    onChange={this.setConfirmEmail}
                    variant="standard"
                    error={(this.state.confirmEmailNotValid && !!this.trans("confirm-email-should-be-equal")) || !!this.getErrorFor("newEmail") || this.state.errorChangeEmailId}
                  />
                  {this.state.confirmEmailNotValid ? <div className="component-error-text">{this.trans("confirm-email-should-be-equal")}</div>
                  :
                  this.state.errorChangeEmailId && <div className="component-error-text">{this.trans(this.state.errorChangeEmailId)}</div>
                  }
                </form>
                <Button
                  variant="contained"
                  color="primary"
                  className="form-button"
                  onClick={this.changeEmail}
                  style={{margin: "10px 0"}}
                >
                  {this.trans("button-save")}
                </Button>
              </div>
            </div>  
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel className="expansion-panel" expanded={this.state.expanded === 'password'} onChange={this.handleChangeExpansionPanel('password')}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            {
              <div className="expansion-panel-title">{this.trans("title-password")}</div>
            }
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="row" style={{width: "400px",  marginLeft: "23px"}}>
              <div className="grid"></div>
              <div className="grid">
                <form>
                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-oldPassword"
                    type="password"
                    label={this.trans("label-current-password")}
                    value={this.state.oldPassword}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "oldPassword")}
                    variant="standard"
                    error={!!this.getErrorFor("oldPassword")}
                  />
                  {!!this.getErrorFor("oldPassword") && <div className="component-error-text">{this.getErrorFor("oldPassword")}</div>}

                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-newPassword"
                    type="password"
                    label={this.trans("label-new-password")}
                    value={this.state.newPassword}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "newPassword")}
                    variant="standard"
                    error={!!this.getErrorFor("newPassword")}
                  />
                  {!!this.getErrorFor("newPassword") && <div className="component-error-text">{this.getErrorFor("newPassword")}</div>}

                  <TextField
                    autoComplete="off"
                    className="form-element full-size scroll-to-newPassword"
                    type="password"
                    label={this.trans("label-confirm-password")}
                    value={this.state.confirmPassword}
                    onChange={this.sync.bind(this, this.syncronizers.EVENT, "confirmPassword")}
                    variant="standard"
                    error={!!this.getErrorFor("newPassword")}
                  />
                  {!!this.getErrorFor("newPassword") && <div className="component-error-text">{this.getErrorFor("newPassword")}</div>}
                </form>
                <Button
                  variant="contained"
                  color="primary"
                  className="form-button"
                  disabled={this.props.component.isChangingPassword}
                  onClick={this.changePassword}
                  style={{margin: "10px 0"}}
                >
                  {this.trans("button-save")}
                </Button>
              </div>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel className="expansion-panel" expanded={this.state.expanded === 'attachemnts'} onChange={this.handleChangeExpansionPanel('attachemnts')}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            {
              <div className="expansion-panel-title">{this.trans("title-attachments")}</div>
            }
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className="expansion-panel-details">
            <div className="expansion-panel-attachments-wrapper">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                title={this.trans("attachments-for-user")}
                amazonFolderName={this.state.user?.amazonFolderName}
                relation="contactId"
                entity={this.state.user}
                attachments={this.state.attachments}
                possibilityToSetAvatar={true}
                onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
                updateParentState={attachments => this.setState({attachments: attachments})}
                withoutBottomMargin={true}
              />
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.userProfile,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  UserProfile
);
